'use strict';

exports.__esModule = true;
exports.GQLSub = undefined;

var _regeneratorRuntime = require('regenerator-runtime');

var _regeneratorRuntime2 = _interopRequireDefault(_regeneratorRuntime);

var _graphqlAnywhere = require('graphql-anywhere');

var _graphqlAnywhere2 = _interopRequireDefault(_graphqlAnywhere);

var _objectHash = require('object-hash');

var _objectHash2 = _interopRequireDefault(_objectHash);

var _rdt = require('@swarm/rdt');

var _ron = require('@swarm/ron');

var _ron2 = _interopRequireDefault(_ron);

var _ronUuid = require('@swarm/ron-uuid');

var _ronUuid2 = _interopRequireDefault(_ronUuid);

var _api = require('@swarm/api');

var _api2 = _interopRequireDefault(_api);

var _utils = require('./utils');

var _deps = require('./deps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // for async/await work flow

var GQLSub = exports.GQLSub = function () {
  function GQLSub(api, client, cache, request, cbk) {
    _classCallCheck(this, GQLSub);

    this.api = api;
    this.request = request;
    this.id = GQLSub.hash(request, cbk);
    // $FlowFixMe
    this.operation = request.query.definitions[0].operation;

    this.client = client;
    this.cache = cache;
    this.cbk = cbk;
    this.deps = new _deps.Dependencies();

    // $FlowFixMe
    this._invoke = this._invoke.bind(this);
    return this;
  } // hash from payload object

  GQLSub.prototype.is = function is(h) {
    return this.id === h;
  };

  GQLSub.prototype.off = function off() {
    if (this.active === true) {
      var ret = false;
      switch (this.operation) {
        case 'query':
        case 'subscription':
          ret = !!this.client.off('', this._invoke);
          this.active = !ret;
          break;
        case 'mutation':
          // do nothing actually b/c we have no any real subscriptions
          this.active = ret = false;
      }
      this.finalizer && this.finalizer(this.id);
      return ret;
    }
    return false;
  };

  GQLSub.prototype.finalize = function finalize(f) {
    this.finalizer = f;
  };

  GQLSub.prototype.start = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee() {
      var res;
      return _regeneratorRuntime2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.active !== undefined)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', false);

            case 2:
              _context.t0 = this.operation;
              _context.next = _context.t0 === 'query' ? 5 : _context.t0 === 'subscription' ? 5 : _context.t0 === 'mutation' ? 8 : 14;
              break;

            case 5:
              this.active = true;
              this.callback();
              return _context.abrupt('break', 15);

            case 8:
              this.active = true;
              _context.next = 11;
              return this.runMutation();

            case 11:
              res = _context.sent;

              this.off();
              return _context.abrupt('return', res);

            case 14:
              throw new Error('unknown operation: \'' + this.operation + '\'');

            case 15:
              return _context.abrupt('return', this.active || false);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function start() {
      return _ref.apply(this, arguments);
    }

    return start;
  }();

  GQLSub.prototype._invoke = function _invoke(l, s) {
    var _this = this;

    // prevent unauthorized calls
    if (this.active === false) {
      this.client.off('', this._invoke);
      return;
    }
    clearTimeout(this.invokeTimer);

    // passable values:
    // - null
    // - {version: '0', id: <id>, type: ''} // server told that there is no data
    // - full state
    var v = null;
    if (s !== null) v = (0, _rdt.ron2js)(s || l);
    // console.log('_invoke', { v, l, s });

    var id = void 0;
    var head = _ron2.default.fromString(l);
    if (head && !head.object.eq(_ronUuid.ZERO)) {
      id = head.object.toString();
    } else return;

    // $FlowFixMe ?
    this.cache[id] = v;
    this.invokeTimer = setTimeout(function () {
      return _this.callback();
    }, 0);
  };

  GQLSub.prototype.subscribe = function subscribe() {
    for (var _iterator = _deps.KINDS, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref2 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref2 = _i.value;
      }

      var kind = _ref2;

      var on = this.deps.toString(kind);
      if (on) {
        var options = this.deps.options(kind);
        this.client.on(on, this._invoke, options);
      }
    }
  };

  GQLSub.prototype.callback = function callback() {
    var _this2 = this;

    if (this.active !== true) return;

    var _buildTree = this.buildTree(),
        ready = _buildTree.ready,
        tree = _buildTree.tree,
        deps = _buildTree.deps;

    var diff = this.deps.diff(deps);
    this.deps = deps;
    var off = diff.toString();
    if (off) this.client.off(off, this._invoke);
    this.subscribe();

    if (!ready) return;

    var cbk = this.cbk;

    if (cbk) {
      if (this.operation !== 'mutation') {
        // drop this sub from
        if (Object.keys(deps.index).length === 0) {
          this.off();
        }
        cbk({
          data: tree,
          off: function off() {
            return _this2.off();
          }
        });
      } else {
        cbk({ data: tree });
      }
    }
  };

  GQLSub.prototype.buildTree = function buildTree() {
    var ctx = {
      ready: true,
      deps: new _deps.Dependencies()
    };

    var tree = (0, _graphqlAnywhere2.default)(this.resolver.bind(this), this.request.query, {}, ctx, this.request.variables);

    return {
      tree: tree,
      ready: ctx.ready,
      deps: ctx.deps
    };
  };

  GQLSub.prototype.resolver = function resolver(fieldName, root, args, context, info) {
    var _obj;

    if (root instanceof _ronUuid2.default) return null;

    // workaround type
    if (fieldName === 'type') fieldName = 'type';

    var value = root[fieldName];
    if (typeof value === 'undefined') value = null;

    // get UUID from @node directive if presented
    // thus, override the value if `id` argument passed
    value = (0, _utils.node)(value, info.isLeaf, info.directives);

    // if atom value is not a UUID or is a leaf, return w/o
    // any additional business logic
    if (!(value instanceof _ronUuid2.default) || info.isLeaf) {
      return (0, _utils.applyScalarDirectives)(value, info.directives);
    }

    var kind = _deps.Dependencies.getKind(this.operation, info.directives);
    var ensure = (kind | 1) !== kind;
    var reactive = (kind | 2) !== kind;
    var id = value.toString();
    // $FlowFixMe
    var obj = this.cache[id];

    if (reactive || typeof obj === 'undefined' || !obj && ensure) {
      context.deps.put(kind, id);
    }

    context.ready = context.ready && this.cache.hasOwnProperty(id);

    for (var _iterator2 = Object.keys(info.directives || {}), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref3 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref3 = _i2.value;
      }

      var key = _ref3;

      // $FlowFixMe
      var dir = info.directives[key];
      switch (key) {
        case 'slice':
          if (!obj) continue;
          if (!Array.isArray(obj)) obj = obj.valueOf();
          // $FlowFixMe
          var _args2 = [dir && dir.begin || 0];
          if (dir && dir.end) _args2.push(dir.end);
          obj = (_obj = obj).slice.apply(_obj, _args2);
          break;
        case 'reverse':
          if (!obj) continue;
          if (!Array.isArray(obj)) obj = obj.valueOf();
          obj.reverse();
          break;
      }
    }

    if (ensure) context.ready = context.ready && !!obj;

    if (!Array.isArray(obj)) return obj;

    for (var i = 0; i < obj.length; i++) {
      if (!(obj[i] instanceof _ronUuid2.default)) continue;
      // $FlowFixMe
      var _value = this.cache[obj[i].toString()];

      if (reactive || typeof _value === 'undefined' || !_value && ensure) {
        // $FlowFixMe
        context.deps.put(kind, obj[i].toString());
      }
      // check if value presented
      if (typeof _value === 'undefined') {
        context.ready = false;
        // $FlowFixMe
      } else if (ensure) context.ready = context.ready && _value && _value.id;
      // $FlowFixMe
      obj[i] = _value || null;
    }

    return obj;
  };

  GQLSub.prototype.runMutation = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee2() {
      var _this3 = this;

      var ctx, tree, all, _loop, _iterator3, _isArray3, _i3, _ref5, key;

      return _regeneratorRuntime2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              ctx = {};
              tree = (0, _graphqlAnywhere2.default)(this.mutation.bind(this), this.request.query, {}, ctx, this.request.variables);
              all = [];

              _loop = function _loop(key) {
                var v = tree[key];
                all.push(Promise.resolve(v).then(function (ok) {
                  tree[key] = ok;
                }));
              };

              _iterator3 = Object.keys(tree), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();

            case 5:
              if (!_isArray3) {
                _context2.next = 11;
                break;
              }

              if (!(_i3 >= _iterator3.length)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt('break', 19);

            case 8:
              _ref5 = _iterator3[_i3++];
              _context2.next = 15;
              break;

            case 11:
              _i3 = _iterator3.next();

              if (!_i3.done) {
                _context2.next = 14;
                break;
              }

              return _context2.abrupt('break', 19);

            case 14:
              _ref5 = _i3.value;

            case 15:
              key = _ref5;

              _loop(key);

            case 17:
              _context2.next = 5;
              break;

            case 19:

              Promise.all(all).then(function () {
                if (_this3.cbk) _this3.cbk({ data: tree });
              }).catch(function (error) {
                if (_this3.cbk) _this3.cbk({ data: null, error: error });
              });

              return _context2.abrupt('return', true);

            case 21:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function runMutation() {
      return _ref4.apply(this, arguments);
    }

    return runMutation;
  }();

  GQLSub.prototype.mutation = function mutation(fieldName, root, args, context, info) {
    if (!info.isLeaf) return false;
    switch (fieldName) {
      case 'set':
        if (!args.payload) return false;
        return this.api.set(args.id, args.payload);
      case 'add':
        return this.api.add(args.id, args.value || null);
      case 'remove':
        return this.api.remove(args.id, args.value || null);
      default:
        return false;
    }
  };

  GQLSub.hash = function hash(request, cbk) {
    return (0, _objectHash2.default)({ request: request, cbk: cbk });
  };

  return GQLSub;
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/db/lib/subscription.js
// module id = 87
// module chunks = 0